<template>
    <div class="text-black" :class="{ 'pb24': this.isMobile }">
        <div class='d-flex align-items-center justify-content-between neue' :class="{ 'mb32': this.isMobile, 'mb16': !this.isMobile }">
            <Icon v-if="this.isMobile" name="arrow-left" class="c24 pointer" @click="this.close" />
            <h4 class="fsp20 lh28 neue mb-0" :class="{ 'text-center mr24 flex-grow-1': this.isMobile }">{{ this.$store.state.modal.content.title }}</h4>
            <Icon v-if="!this.isMobile" name="close" class="c24 pointer" @click="this.close" />
        </div>
        <div class='container-fluid mt-1 p-0 g-3 bg-white rounded12' :class="{ 'p24': !this.isMobile }">
            <h4 class='fsp20 lh28 neue mb16'>{{ this.$t('components.service.modal.Emission.15') }}</h4>
            <div class="d-flex mb16" :class="{ 'flex-column align-items-start gap-2': this.isMobile, 'align-items-center gap-3': !this.isMobile }">
                <div class="neue-roman fsp14 lh20 w-136">
                    {{ $t('components.service.modal.BurnEmission.2') }}
                </div>
                <InputSimple
                    type='text'
                    :dataValue='this.data.burn_amount'
                    :invalid='this.summWarn'
                    :invalidHint='this.summWarn'
                    :regCheck="{f: this.$lib.summValidate}"
                    id='burn_amount'
                    @updateParentState="this.updateState"
                    >
                    <div class="primary-grey mr12">
                        {{ this.sub_data.ticker }}
                    </div>
                </InputSimple>
            </div>
            <div class="d-flex justify-content-between pb16 mb16 gap-3" :class="{ 'flex-column align-items-start': this.isMobile, 'align-items-center': !this.isMobile }">
                <div class="d-flex align-items-center justify-content-between gap-3 h40" :class="{ 'equal-width': !this.isMobile && this.data.burn_amount, 'w-100': this.isMobile, 'col-6': !this.data.burn_amount }">
                    <div class="neue-roman fsp14 lh20 w-136" :class="{ 'equal-width': !this.isMobile && this.data.burn_amount }">
                        {{ this.$t('components.service.modal.Emission.8') }}
                    </div>
                    <span class="neue flex-grow-1 fsp14 lh20" :class="{ 'equal-width': !this.isMobile, '': this.isMobile }">
                        {{ this.sub_data.current_emission }} {{ this.sub_data.ticker }}
                    </span>
                </div>
                <div v-if="this.data.burn_amount" class="d-flex align-items-center justify-content-between gap-3 h40" :class="{ 'equal-width': !this.isMobile, 'w-100': this.isMobile }">
                    <div v-if="this.data.burn_amount" class="neue-roman fsp14 lh20 w-136" :class="{ 'equal-width flex-grow-1 text-end': !this.isMobile }">
                        {{ this.$t('components.service.modal.Emission.28') }}
                    </div>
                    <span v-if="this.data.burn_amount" class="neue flex-grow-1 fsp14 lh20" :class="{ 'equal-width': !this.isMobile, '': this.isMobile }">
                        {{ Number(this.sub_data.current_emission) - Number(this.data.burn_amount) < 0 ? 0 : Number(this.sub_data.current_emission) - Number(this.data.burn_amount) }} {{ this.sub_data.ticker }}
                    </span>
                </div>
            </div>
            <div v-show="this.comiss" class="mb16 pb16 border-t pt16">
                <div class="d-flex justify-content-between align-items-center mb16">
                    <h4 class='fsp20 lh28 neue mb-0'>{{ this.$t('components.service.modal.Emission.11') }}</h4>
                    <div class="neue color-menu text-decoration-underline pointer">{{ this.$t('components.service.modal.Emission.30')}}</div>
                </div>
                <Comiss :sum="this.data.burn_amount"
                    ref="comiss"
                    @updateParentState='this.setSummWarn'
                    @onSuccess="this.readyCheck"
                    :params = "this.setParams()"
                    :cmd_name="'burn_custom_curr'"
                    :precision="'2'"
                    :curr="this.sub_data.ticker"
                    :hide_comiss="true"
                />
                <div class="d-flex justify-content-between mt16" :class="{ 'flex-column align-items-start gap-2': this.isMobile, 'align-items-center gap-3': !this.isMobile }">
                    <div class="neue-roman fsp14 lh20 w-136">{{ this.$t('components.service.modal.Emission.4') }}</div>
                    <SelectSimple
                        id='commission_from_keyt'
                        :dataValue='this.data.commission_from_keyt'
                        :keywords.sync='this.keywords'
                        @updateParentState="this.updateState"
                        :isSearch="true"
                        :keyt="true"
                    />
                </div>
            </div>
            <div v-if="(this.sub_data.bind_fiat_curr && this.sub_data.cover_percent !== '0.00') || this.sub_data.cover_amount !== '0.00'" class="border-t pt16">
                <h4 class='fsp20 lh28 neue mb16'>{{ this.$t('components.service.modal.Emission.10') }}</h4>
                <div class="d-flex justify-content-between gap-3 mb16" :class="{ 'flex-column align-items-start': this.isMobile, 'align-items-center': !this.isMobile }">
                    <div class="d-flex align-items-center justify-content-between gap-3 lh20 h40" :class="{ 'w-100': this.isMobile, 'equal-width': !this.isMobile }">
                        <div class="neue-roman fsp14 w-136">{{ this.$t('components.service.modal.Emission.21') }}</div>
                        <span class="neue flex-grow-1 fsp14">
                            {{ this.sub_data.cover_percent !== '0.00' ? this.calculatingCurrencyCoverage() : this.sub_data.cover_amount || 0 }} {{ this.sub_data.bind_fiat_curr_text }}
                        </span>
                    </div>
                    <div v-if="this.sub_data.cover_percent !== '0.00' && this.sub_data.cover_percent" class="d-flex align-items-center justify-content-between gap-3 lh20 h40" :class="{ 'w-100': this.isMobile, 'equal-width': !this.isMobile }">
                        <div class="neue-roman fsp14 w-136" :class="{ 'text-end': !this.isMobile }">{{ this.$t('components.service.modal.Emission.16') }}</div>
                        <span class="neue flex-grow-1 fsp14">
                            <span class="neue">{{ this.sub_data.cover_percent }} %</span>
                        </span>
                    </div>
                </div>
                <div v-if="this.sub_data.bind_fiat_curr" class="d-flex align-items-center justify-content-between gap-3 mb16 lh20 h40">
                    <div class="d-flex align-items-center justify-content-between gap-3 w-100">
                        <div class="neue-roman fsp14 w-136">{{ this.$t('components.service.modal.Emission.14') }}</div>
                        <span class="neue flex-grow-1 fsp14">
                            {{ this.sub_data.bind_custom_count }}
                            {{ this.sub_data.ticker }}
                            &nbsp;=&nbsp;
                            {{ this.sub_data.bind_fiat_count }}
                            {{ this.sub_data.bind_fiat_curr_text }}
                        </span>
                    </div>
                </div>
                <div v-if="this.sub_data.cover_percent !== '0.00'" class="d-flex align-items-center justify-content-between gap-3 mb16 lh20 h40">
                    <div class="d-flex align-items-center">
                        <div class="d-flex align-items-center neue-roman fsp14 w-136">
                            {{ this.$t('components.service.modal.Emission.17') }}
                            <Popper :hover="true" :modalSide="!this.isMobile">
                                <Icon name="info" class="c16 ml8" />
                                <template #content>
                                    <div class="fsp14 neue-roman text-white">{{ this.$t('components.service.modal.BurnEmission.11') }}</div>
                                    <div class="fsp14 neue text-white text-nowrap">{{ this.$t('components.service.modal.BurnEmission.12') }}</div>
                                    <pre class="neue-roman fsp14 text-white ml4 mb-0">{{ this.$t('components.service.modal.BurnEmission.13') }}</pre>
                                </template>
                            </Popper>
                        </div>
                    </div>
                    <span class="neue flex-grow-1 fsp14">
                        <span class="primary-grey">(</span><span class="color-menu">{{ this.sub_data.current_emission }}</span> <span class="primary-grey">{{ this.sub_data.ticker }} - </span>
                        <span class="color-menu">{{ this.data.burn_amount || 0 }}</span> <span class="primary-grey">{{ this.sub_data.ticker }}) × </span>
                        <span class="color-menu">{{ this.sub_data.bind_fiat_count }}</span> <span class="primary-grey">{{ this.sub_data.bind_fiat_curr_text }} × </span>
                        <span class="color-menu">{{ this.sub_data.cover_percent }}%</span><span class="primary-grey"> = </span>
                        <span class="color-menu">{{ this.calculateCoverage() }}</span>&nbsp;
                        <span class="primary-grey">{{ this.sub_data.bind_fiat_curr_text }}</span>
                    </span>
                </div>
                <div v-if="this.sub_data.cover_percent !== '0.00'">
                    <h4 class='fsp20 lh28 neue mb16'>{{ this.$t('components.service.modal.BurnEmission.14') }}</h4>
                    <div class="d-flex col-12 align-items-center gap-3 mb16 lh20 h40">
                        <div class="d-flex align-items-center">
                            <div class="d-flex align-items-center neue-roman w-136 fsp14 neue-roman">
                                {{ this.$t('components.service.modal.BurnEmission.8') }}
                                <Popper :hover="true" :modalSide="!this.isMobile">
                                    <Icon name="info" class="c16 ml8" />
                                    <template #content>
                                        <div class="text-white">{{ this.$t('components.service.modal.BurnEmission.15') }}</div>
                                    </template>
                                </Popper>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between align-items-md-center">
                            <div class="fsp14 neue">
                                <span class="color-menu">{{ this.calculateCoverage() }}</span> <span class="primary-grey">{{ this.sub_data.bind_fiat_curr_text }} - </span>
                                <span class="color-menu">{{ this.calculatingCurrencyCoverage() }}</span> <span class="primary-grey">{{ this.sub_data.bind_fiat_curr_text }} = </span>
                                <span class="color-menu">{{ this.calculateReverse() }}&nbsp;</span>
                                <span class="primary-grey">{{ this.sub_data.bind_fiat_curr_text }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between" :class="{ 'flex-column align-items-start gap-2': this.isMobile, 'align-items-center gap-3': !this.isMobile }">
                        <div class="neue-roman fsp14 w-136">{{ this.$t('components.service.modal.BurnEmission.3') }}</div>
                        <SelectSimple
                            id='cover_return_keyt'
                            :dataValue='this.data.cover_return_keyt'
                            :keywords.sync='this.keywords'
                            @updateParentState="this.updateState"
                            :isSearch="true"
                            :keyt="true"
                        />
                    </div>
                </div>
            </div>
            <div class="d-flex gap-3 mt24" :class="{ 'position-fixed bottom-0 left-0 end-0 bg-white py16 px24 border-t w-100 flex-row-reverse': this.isMobile }">
                <Button
                    class="h48 equal-width"
                    :name="$t('components.service.modal.Emission.29')"
                    v-on:click="this.close"
                    type='btn-outline-grey'
                />
                <Button
                    class="h48 equal-width"
                    :name="this.isMobile ? this.$t('components.service.modal.Emission.31') : $t('components.service.modal.BurnEmission.4')"
                    v-on:click="this.burnDo"
                    type='btn-warning'
                    :disabled='!this.ready'
                />
            </div>
        </div>
    </div>
</template>

<script>
import Button from '@/components/service/Button';
import InputSimple from '@/components/service/InputSimple';
import Comiss from '@/components/service/Comiss';
import Select from '@/components/service/Select';
import Tooltip from '@/components/service/Tooltip';
import Icon from '@/components/icons/Icon';
import SelectSimple from '@/components/service/SelectSimple';
import Popper from '@/components/service/Popper';

export default {
    components: {
        Button,
        Comiss,
        Select,
        Tooltip,
        Icon,
        SelectSimple,
        Popper,
        InputSimple,
    },
    props: {
        close: [Function],
    },
    computed: {
        t () {
            let k = this.$store.getters.get_keyts_keywords;
            if (k.length > 0) {
                this.getKeyts(k);
            }
            return k;
        },
        isMobile() {
            return this.$store.state.resize.w <= 768;
        }
    },
    data () {
        return {
            comiss: '',
            curr: this.$store.state.modal.content.curr,
            currs: this.$store.state.modal.content.currs,
            keywords: [],
            data: {
                comment: '',
                commission_from_keyt: '',
                cover_return_keyt: '',
                custom_curr: this.$store.state.modal.content.curr.alias,
                burn_amount: '',
                auto_rate: '1'
            },
            sub_data: {
                current_emission: this.$store.state.modal.content.curr.current_emission,
                ticker: this.$store.state.modal.content.curr.alias,
                bind_custom_count: this.$store.state.modal.content.curr.bind_custom_count,
                bind_fiat_count: this.$store.state.modal.content.curr.bind_count,
                bind_fiat_curr: this.$store.state.modal.content.curr.bind_currency,
                bind_fiat_curr_text: this.$store.state.modal.content.curr.bind_curr_text,
                cover_percent: this.$store.state.modal.content.curr.cover_percent,
                cover_amount: this.$store.state.modal.content.curr.cover_amount || '0.00',
            },
            summWarn: false,
            ready: false,
        }
    },
    watch: {
        'data.burn_amount': {
            handler: function(newData) {
                if(Number(newData) <= Number(this.sub_data.current_emission) && this.summWarn) {
                    this.summWarn = false;
                }
            },
            deep: true,
        },
        'data.cover_return_keyt': {
            handler: function(newData, oldData) {
                if(Number(this.data.burn_amount) <= Number(this.sub_data.current_emission) && this.summWarn && newData) {
                    this.summWarn = false;
                }
            },
            deep: true,
        },
        t: {
            handler: function(newData, oldData) {
                this.getKeyts(newData);
            },
            deep: true,
        }
    },
    methods: {
        calculateCoverage() {
            return this.$lib.precRound(this, (Number(this.sub_data.current_emission) - Number(this.data.burn_amount)) * Number(this.sub_data.bind_fiat_count) * Number(this.sub_data.cover_percent) / 100, 2);
        },
        calculatingCurrencyCoverage() {
            return this.$lib.precRound(this, Number(this.sub_data.current_emission) * Number(this.sub_data.bind_fiat_count)* Number(this.sub_data.cover_percent) / 100, 2);
        },
        calculateReverse() {
            return this.calculatingCurrencyCoverage() - this.calculateCoverage();
        },
        getKeyts(k) {
            const k_copy = structuredClone(k);
            k_copy.sort((a, b) => {
                if(a.curr === this.sub_data.bind_fiat_curr_text) {
                    return -1;
                }
                if(b.curr === this.sub_data.bind_fiat_curr_text) {
                    return 1;
                }
                return 0;
            })
            this.keywords = k_copy;
        },
        setParams() {
            let params = Object.assign({}, this.data);

            for(let k in params) {
                if( params[k] == '' ) {
                    delete params[k];
                }
            }

            delete params['comiss'];

            return params;
        },
        readyCheck(arg) {
            this.ready = arg;
        },
        setSummWarn(arg) {
            this.summWarn = arg
        },
        updateState(state) {
            if(this.ready && state.id === 'burn_amount' && !state.value) {
                this.ready = false;
            }
            this.data[state.id] = state.value;
        },
        burnDo() {
            this.$store.dispatch('openModal', {
                action: true,
                type: 'pay_pass',
                content: {localLoader: true, callback: () => {
                    // localLoader: PayPass держит себя открытой со спиннером на кнопке,
                    // пока идёт сжигание — без глобального оверлея. Возвращаем промис,
                    // запрос с no_loader. На успехе модалка уходит в 'answer'/'result'.
                    return this.axios.post('BurnCurrency', {no_loader: true, data: this.setParams()}).then(res => {
                        if(res.data.body.result !== '0') {
                            return;
                        }
                        if (res.data.body.transact !== '0') {
                            this.$store.commit('SET_RESULT', res.data.body);
                            this.$router.push('/result');
                        } else {
                            this.$store.commit('MODAL_ACTION', true);
                            this.$store.commit('MODAL_TYPE', 'answer');
                        }
                    });
                }},
            });
        },
        updateComiss(comiss) {
            this.data.comiss = Number(comiss);
        }
    },
    mounted() {
    }
}
</script>

<style lang="scss" scoped>
    .answer_content :deep(a) {
            color: $color-href !important;
    }

    .color-active {
        color: $dark-orange;
    }

    .grey-block {
        background: $menu-base;
        border: 1px solid $color-lightgrey;
        border-radius: 6px;
    }

    .w-136 {
        width: 136px !important;
        flex-shrink: 0;
    }
</style>
